function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.578 8.528c-6.904 0-11.538 4.037-11.538 11.875v5.584a5.16 5.16 0 012.234-.512c.81 0 1.575.192 2.259.524v-5.596c0-5.083 2.79-7.695 7.045-7.695 4.257 0 7.046 2.612 7.046 7.695v12.206h4.493V20.403c0-7.885-4.634-11.875-11.538-11.875zM57.977 18.456c-.9-3.735-3.976-5.767-7.762-5.767-3.882 0-6.815 2.08-7.715 5.767h15.477zM37.626 20.82c0-7.09 5.205-12.29 12.589-12.29 7.383 0 12.494 5.2 12.494 12.29v1.655H42.36c.662 4.16 3.786 6.476 7.856 6.476 3.028 0 5.159-.945 6.531-2.977h4.97c-1.799 4.349-6.058 7.137-11.501 7.137-7.384 0-12.59-5.2-12.59-12.29zM85.273 20.82c0-4.728-3.206-8.132-8.015-8.132-4.81 0-8.015 3.404-8.015 8.131 0 4.728 3.205 8.131 8.015 8.131 4.809 0 8.015-3.403 8.015-8.13zm-20.557 0c0-7.092 5.187-12.292 12.542-12.292 7.355 0 12.541 5.2 12.541 12.291S84.613 33.11 77.258 33.11s-12.542-5.2-12.542-12.29zM115.385 37.274h.522c2.899 0 3.992-1.273 3.992-4.57V9.531h4.516V32.42c0 5.748-2.281 8.717-8.081 8.717h-.949v-3.863zM96.615 23.755c-.131.186-.208.414-.208.66 0 .63.496 1.137 1.113 1.137h11.102v-14.48a1.108 1.108 0 00-.771-1.1 1.391 1.391 0 00-.401-.057c-.271 0-.605.097-.88.476l-9.953 13.36-.002.004zm16.439 11.362h-4.432v-5.564h-11.24c-2.243 0-4.19-1.119-5.08-2.918-.833-1.685-.607-3.683.605-5.345l10.102-13.468c1.455-1.996 3.897-2.786 6.215-2.008 2.321.776 3.824 2.884 3.83 5.369v14.369h3.334v4.001h-3.334v5.564z",
  fill: "#000"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M118.395 0h7.525v7.525h-7.525V0z",
  fill: "#fff"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#aura-ds-colored_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M118.395 3.763a3.766 3.766 0 003.762 3.762 3.767 3.767 0 003.763-3.762A3.767 3.767 0 00122.157 0a3.766 3.766 0 00-3.762 3.763z",
  fill: "#018BFF"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M0 20.067h18.06v21.572H0V20.067z",
  fill: "#fff"
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#aura-ds-colored_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.187 27.027c-.875 0-1.68.291-2.328.775l-4.26-2.875c.093-.33.147-.676.147-1.035 0-2.109-1.737-3.825-3.873-3.825S0 21.783 0 23.892c0 2.11 1.737 3.826 3.873 3.826.875 0 1.68-.29 2.328-.775l4.26 2.875c-.094.33-.147.676-.147 1.035 0 .359.053.705.147 1.035l-4.26 2.875a3.879 3.879 0 00-2.328-.775C1.737 33.988 0 35.704 0 37.813c0 2.11 1.737 3.826 3.873 3.826s3.873-1.716 3.873-3.826c0-.359-.054-.705-.147-1.034l4.26-2.876a3.878 3.878 0 002.328.776c2.136 0 3.873-1.716 3.873-3.826 0-2.11-1.737-3.826-3.873-3.826z",
  fill: "#018BFF"
}));

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M144.208 30.26c3.034 0 5.626-1.485 6.732-4.266v3.855h1.96v-7.711c0-4.93-3.445-8.312-8.376-8.312-4.93 0-8.407 3.444-8.407 8.312 0 4.993 3.698 8.122 8.091 8.122zm.316-1.96c-3.729 0-6.258-2.654-6.258-6.257 0-3.603 2.529-6.258 6.258-6.258 3.73 0 6.258 2.655 6.258 6.258s-2.528 6.258-6.258 6.258zm23.951 1.96c4.614 0 7.711-2.686 7.711-7.87v-8.154h-2.117v8.155c0 3.824-2.213 5.91-5.594 5.91-3.382 0-5.595-2.086-5.595-5.91v-8.155h-2.117v8.155c0 5.183 3.097 7.87 7.712 7.87zm17.692-.41v-9.356c0-3.255 1.77-4.709 4.456-4.709 2.655 0 4.457 1.454 4.457 4.71v.22h2.086v-.19c0-4.519-2.655-6.7-6.543-6.7-3.887 0-6.574 2.181-6.574 6.67v9.354h2.118zm25.309.41c3.034 0 5.626-1.485 6.732-4.266v3.855h1.96v-7.711c0-4.93-3.445-8.312-8.376-8.312-4.93 0-8.407 3.444-8.407 8.312 0 4.993 3.698 8.122 8.091 8.122zm.316-1.96c-3.729 0-6.257-2.654-6.257-6.257 0-3.603 2.528-6.258 6.257-6.258 3.73 0 6.258 2.655 6.258 6.258s-2.528 6.258-6.258 6.258z",
  fill: "#000"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M233.713 30.1c5.599 0 8.598-3.246 8.598-8.102 0-4.857-2.999-8.103-8.598-8.103h-5.799V30.1h5.799zm0-1.635h-4.015V15.531h4.015c4.584 0 6.814 2.577 6.814 6.467 0 3.89-2.23 6.467-6.814 6.467zM253.838 30.422c3.568 0 5.897-1.907 5.897-4.93 0-3.227-2.464-3.86-4.922-4.271l-.238-.04a13.347 13.347 0 00-.079-.012l-.158-.026a13.543 13.543 0 00-.079-.012c-2.205-.347-4.237-.694-4.237-2.776 0-1.908 1.487-3.147 3.841-3.147 2.329 0 3.741 1.19 3.841 3.048h1.709c-.099-2.825-2.279-4.683-5.55-4.683-3.345 0-5.575 1.957-5.575 4.832 0 2.962 2.089 3.743 4.344 4.14l.158.027c.237.04.475.076.712.11l.158.023.079.011.321.048.16.024c2.014.314 3.781.778 3.781 2.753 0 1.982-1.586 3.246-4.163 3.246s-4.088-1.19-4.163-3.246h-1.759c.074 3.023 2.404 4.881 5.922 4.881z",
  fill: "#018BFF"
});

function SvgAuraDsColored(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 42,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("mask", {
    id: "aura-ds-colored_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 118,
    y: 0,
    width: 8,
    height: 8
  }, _ref3), _ref4, /*#__PURE__*/React.createElement("mask", {
    id: "aura-ds-colored_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 20,
    width: 19,
    height: 22
  }, _ref5), _ref6, _ref7, _ref8);
}

export default SvgAuraDsColored;